import React from 'react';
import { FileText, ExternalLink, Calendar } from 'lucide-react';
import LoadingSpinner from './LoadingSpinner';
import { useFundData } from '../context/FundDataContext';
import { formatFullDate } from '../utils/format';

function Letters() {
  const { letters, ready } = useFundData();

  if (!ready) {
    return <LoadingSpinner text="Loading letters..." />;
  }

  return (
    <>
      <div className="client-page-head">
        <h1 className="client-page-title">Letters &amp; reports</h1>
        <p className="client-page-sub">Quarterly updates and annual reports</p>
      </div>

      {letters.length === 0 ? (
        <div className="c-card c-empty">No letters have been published yet.</div>
      ) : (
        <div className="c-letters-grid">
          {letters.map((letter) => (
            <a
              key={letter.id}
              href={letter.url}
              target="_blank"
              rel="noopener noreferrer"
              className="c-card c-letter-card"
            >
              <div className="c-letter-icon">
                <FileText size={22} />
              </div>
              <div className="c-letter-body">
                <span className="c-letter-badge">{letter.type}</span>
                <p className="c-letter-title">{letter.title}</p>
                <span className="c-letter-date">
                  <Calendar size={13} />
                  {formatFullDate(letter.date)}
                </span>
              </div>
              <ExternalLink size={18} className="c-letter-arrow" />
            </a>
          ))}
        </div>
      )}
    </>
  );
}

export default Letters;
